{
  "killSwitch": false,
  "disabledPlugins": []
}
